import { components } from "react-select";
import User from "../view/listings/User";
import Login from "../view/Login";
import Area from "../view/listings/Area";
import Plan from "../view/listings/Plan";
import Customer from "../view/listings/Customer";
import Complaint from "../view/listings/Complaint";
import Collection from "../view/listings/Collection";
import Report from "../view/listings/Report";
import Dashboard from "../view/listings/Dashboard";
import UserCreation from "../view/creations/UserCreation";
import CustomerCreation from "../view/creations/CustomerCreation";
import ComplaintCreation from "../view/creations/ComplaintCreation";
import CollectionCreation from "../view/creations/CollectionCreation";
import Staff from "../view/listings/Staff";
import StaffCreation from "../view/creations/StaffCreation";

const routes = [
  { path: "/", component: Login },
  { path: "/dashboard", component: Dashboard },
  { path: "/users", component: User },
  { path: "/users/create", component: UserCreation },
  { path: "/staff", component: Staff },
  { path: "/staff/create", component: StaffCreation },
  { path: "/customer", component: Customer },
  { path: "/customer/create", component: CustomerCreation },
  { path: "/customer/edit/:id", component: CustomerCreation },
  { path: "/complaint", component: Complaint },
  { path: "/complaint/create", component: ComplaintCreation },
  { path: "/complaint/edit/:id", component: ComplaintCreation },
  { path: "/collection", component: Collection },
  { path: "/collection/create", component: CollectionCreation },
  { path: "/collection/edit/:id", component: CollectionCreation },
  { path: "/report", component: Report },
  {
    path: "/master",
    submenu: [
      { path: "/master/area", component: Area },
      { path: "/master/plan", component: Plan },
    ],
  },
];

export default routes;
